import { makeStyles, Theme, Typography } from "@material-ui/core"
import MyTheme from "../../../../../assets/theme/MyTheme";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: 100,
        height: 100,
        borderRadius: '50%',
        background: 'linear-gradient(225.89deg,#fc5e22 -1.1%,#fc992c 99.53%) no-repeat',
        color: 'white',
        position: 'absolute',
        left: 236,
        top: 50,
        zIndex: MyTheme.zIndex.onfocus
        //boxShadow: 'inset -6px -7px 4px 0px rgba(0,0,0,0.3);'
    },
    circleTxt: {
        /* CENTER TEXT IN CIRCLE */
        position: 'absolute',
        bottom: '50%',
        top: 30,
        left: -5,
        textAlign: 'center',
        fontWeight: 'bold',
        transform: 'rotate(-15deg)'

    }
}));

const EmpfehlungPoint: React.FC = () => {
    const classes = useStyles();

    return (
        <div style={{ position: 'relative', display: 'inline' }}>
            <div className={classes.root}>
                <Typography variant='caption' className={classes.circleTxt} color='inherit'>UNSERE EMPFEHLUNG</Typography>
            </div>
        </div>);
}

export default EmpfehlungPoint;